import service from '@/services/superaccess'

const sync = {
  state: {
    sync_modal: false
  },
  mutations: {
    updateStatusSyncModal (state, status) {
      state.sync_modal = status
    }
  },
  actions: {
    setStatusSyncModal (context, payload) {
      context.commit('updateStatusSyncModal', payload)
    },
    rebootSync (context, payload) {
      return service.get('/api/configuration/reboot_sync', context)
    }
  }
}

export default sync



// WEBPACK FOOTER //
// app/javascript/src/store/sync.js